<template>
  <nav class="navbar navbar-expand-lg border-0">
    <div class="container-fluid mt-3 mb-0">
      <div></div>
      <button
        type="button"
        class="d-flex align-items-center border-0 text-primary bg-transparent mr-2"
        :class="{ toggled: $sidebar.showSidebar }"
        v-if="windowWidth < 992"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <b>Menú</b><span class="bi-list text-primary h2 m-0"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a
              class="nav-link d-flex align-items-center"
              style="cursor: pointer"
              @click.prevent="gotoprofile()"
              >Mi Cuenta<i class="bi bi-person-circle ml-2"></i>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link text-danger d-flex align-items-center"
              style="cursor: pointer"
              @click.prevent="logout()"
            >
              Salir<i class="bi bi-door-open-fill ml-1"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  computed: {
    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  data() {
    return {
      activeNotifications: false,
      windowWidth: window.innerWidth
    }
  },
  methods: {
    ...mapActions(['logout']),
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    gotoprofile() {
      this.$router.push({ name: 'UserProfile' })
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>
